
// 参考 https://github.com/matthewhudson/device.js/blob/master/lib/device.js
let userAgent = window.navigator.userAgent.toLowerCase();
function find(needle) {
	return userAgent.indexOf(needle) !== -1;
}
const iphone = function () {
	return !windows() && find('iphone');
};
const ipod = function () {
	return find('ipod');
};
const ipad = function () {
	return find('ipad');
};
const android = function () {
	return !windows() && find('android');
};
const androidPhone = function () {
	return android() && find('mobile');
};
const androidTablet = function () {
	return android() && !find('mobile');
};
const blackberry = function () {
	return find('blackberry') || find('bb10') || find('rim');
};
const blackberryPhone = function () {
	return blackberry() && !find('tablet');
};
const blackberryTablet = function () {
	return blackberry() && find('tablet');
};
const windows = function () {
	return find('windows');
};
const windowsPhone = function () {
	return windows() && find('phone');
};
const windowsTablet = function () {
	return windows() && (find('touch') && !windowsPhone());
};
const fxos = function () {
	return (find('(mobile;') || find('(tablet;')) && find('; rv:');
};
const fxosPhone = function () {
	return fxos() && find('mobile');
};
const fxosTablet = function () {
	return fxos() && find('tablet');
};
const meego = function () {
	return find('meego');
};

export const isMobile = () => {
	if (find('mi pad')) { // 兼容小米平板的设备判断
		return false;
	}
	return androidPhone() || iphone() || ipod() || windowsPhone() || blackberryPhone() || fxosPhone() || meego() ;
}

export const isTablet = () => {
	return ipad() || androidTablet() || blackberryTablet() || windowsTablet() || fxosTablet() || find('mi pad'); // 兼容小米平板的设备判断
}